export default class CollectStatsOnPatRule {
    // eslint-disable-next-line no-unused-vars
    applicable(gameContext, ruleContext, eventConfiguration, { play }) {
        const { collectStatsOnPat } = gameContext?.gameConfig?.general || {};
        return !!collectStatsOnPat;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration) {}
}
